module.exports = __webpack_public_path__ + "static/media/Logo_SAM.d0c89e79.jpg";